<template>
   <div>
     <div class="setting-item">
       <el-checkbox v-model="isShowPreContent">显示IP归属</el-checkbox>
       <div v-show="isShowPreContent" class="content card mt12">
         <div class="content-item verticallyCenter mb12">
           <span class="label mr6">校内IP显示为</span>
           <el-input type="text" class="flex1" v-model="inPreContent" placeholder="请输入"></el-input>
         </div>
         <div class="content-item verticallyCenter">
           <span class="label mr6">校外IP显示为</span>
           <el-input type="text" class="flex1" v-model="outPreContent" placeholder="请输入"></el-input>
         </div>
       </div>
     </div>
     <div class="setting-item mt12">
       <el-checkbox v-model="isShowIp">显示IP值</el-checkbox>
     </div>
     <div class="setting-item mt12" v-show="isShowPreContent && isShowIp">
       <span>间距</span>
       <slider-and-input :value.sync="preContentMargin"  :sliderMax="100" suffix="px" />
     </div>
   </div>
</template>
<script>
export default {
  name:'ip-content-setting',
  data() {
    return {
      activeNames:[1],
      collapseActiveNames:[1]
    }
  },
  props:{
    options: {
      type: Object,
      required: true
    },
    ids:{
      type: Object,
      required: true
    }
  },
  computed: {
    inPreContent:{
      get(){
        return  this.options.inPreContent || ''
      },
      set(newVal){
        this.$changeOptionsEV(newVal, "inPreContent", false, undefined, this.ids)
      }
    },
    outPreContent:{
      get(){
        return  this.options.outPreContent || ''
      },
      set(newVal){
        this.$changeOptionsEV(newVal, "outPreContent", false, undefined, this.ids)
      }
    },
    isShowPreContent:{
      get(){
        return this.options.isShowPreContent
      },
      set(newVal){
        this.$changeOptionsEV(newVal, "isShowPreContent", false, undefined, this.ids)
      }
    },
    isShowIp:{
      get(){
        return this.options.isShowIp
      },
      set(newVal){
        this.$changeOptionsEV(newVal, "isShowIp", false, undefined, this.ids)
      }
    },
    preContentMargin:{
      get(){
        return this.options.preContentMargin || 0
      },
      set(newVal){
        this.$changeOptionsEV(newVal, "preContentMargin", false, undefined, this.ids)
      }
    }
  }
}
</script>
<style scoped>

</style>